import React, { Component, Fragment } from 'react'
import { Elements, StripeProvider } from 'react-stripe-elements'
import { Dialog, withStyles, DialogContent, DialogTitle } from '@material-ui/core'
import PaymentForm from './PaymentForm'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { SETTINGS } from '../../../constants'

const styles = theme => ({
  paper: {
    borderRadius: '0',
    maxWidth: '374px',
    padding: '10px',
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      margin: '0 !important',
      height: '100vh',
      padding: '0',
    },
  },
  paymentCardheading: {
    fontSize: '27px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '20px',
    },
  },
  paymentCardprice: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#a9aeba',
    marginTop: '5px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '0px',
    },
  },
})

class CheckoutForm extends Component {
  render() {
    const { open, onClose, classes, from, history } = this.props

    return (
      <StripeProvider apiKey={process.env.REACT_APP_STRIPE_KEY}>
        <div>
          <Dialog classes={{ paper: classes.paper }} id="detail" open={open} onClose={() => onClose()} scroll={'body'} aria-labelledby="scroll-dialog-title">
            <Fragment>
              <DialogTitle id="scroll-dialog-title">
                <div className={classes.paymentCardheading}>{from !== SETTINGS ? 'Premium Membership' : 'Change Card'}</div>
                <div className={classes.paymentCardprice} hidden={from === SETTINGS}>
                  at $29.99/mo
                </div>
              </DialogTitle>

              <DialogContent>
                <Elements fonts={[{ cssSrc: 'https://fonts.googleapis.com/css?family=Rubik:400,500' }]}>
                  <PaymentForm history={history} onClose={() => onClose()} from={from} onTokenCreate={token => this.props.onTokenCreate(token)} />
                </Elements>
              </DialogContent>
            </Fragment>
          </Dialog>
        </div>
      </StripeProvider>
    )
  }
}

CheckoutForm.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  onTokenCreate: PropTypes.func,
}

export default withStyles(styles)(connect()(CheckoutForm))



// WEBPACK FOOTER //
// ./src/features/payment/components/CheckoutForm.js